import React, { useCallback, useMemo } from 'react'
import { saveAs } from 'file-saver';

import { ReactComponent as Download } from '../../assets/dowload.svg'
import { ReactComponent as Share } from '../../assets/share.svg'
import { ReactComponent as Exite } from '../../assets/Exite.svg'

import parseCurrency from '../../utils/parseCurrency';
import SendGTAGEvent from '../../utils/sendGTAGEvent';

import ModalBackdrop from '../ModalBackdrop';

import { ExiteButtonCard, BlockWishList, Content, Informations, PricesContainer, Cards } from './styles';
import useWishList from '../../hooks/WishListContext';

export interface BaseModalWrapperProps {
  isModalVisible: boolean;
  onBackdropClick: () => void;
  informations: {
    img: string;
    name: string;
    ref: string;
    href: string;
    price: {
      oldPrice: number;
      discountPrice: number;
    }
  }
}
const BaseModalImage: React.FC<BaseModalWrapperProps> = ({ isModalVisible, onBackdropClick, informations }) => {

  const { onShareLinkHandlerItem } = useWishList()

  const checkIfHasDiscount = useMemo(() => {
    return informations.price.discountPrice !== informations.price.oldPrice
  }, [informations.price.discountPrice, informations.price.oldPrice])

  const price = useMemo(() => {
    if (checkIfHasDiscount) {
      return (
        <PricesContainer>
          <p className='p__old__value'> {parseCurrency(informations.price.oldPrice)} </p>
          <p className='p__discount'> {parseCurrency(informations.price.discountPrice)} </p>
        </PricesContainer>
      )
    } else {
      return (
        <p> {parseCurrency(informations.price.discountPrice)} </p>
      )
    }
  }, [checkIfHasDiscount, informations.price.discountPrice, informations.price.oldPrice])

  const onDownloadImageHandler = useCallback(() => saveAs(informations.img, `${informations.name}.jpg`), [informations.img, informations.name])

  return (
    <ModalBackdrop isOpen={isModalVisible} onClose={onBackdropClick}>
      <BlockWishList>
        <ExiteButtonCard>
          <Exite className="svg__exit_image--button" onClick={onBackdropClick} />
        </ExiteButtonCard>

        <img src={informations.img} alt={informations.name} onClick={() => {
          SendGTAGEvent(
            'click-morto_modal_produto',
            'Produto',
            'Clica na imagem do produto na tela de modal',
          )
        }} />
        <Content>

          <Informations>
            <h6> {informations.name} </h6>
            {price}
            <small>Ref.: {informations.ref}</small>
          </Informations>

          <Cards>
            <button className='card__dowload'
              onClick={() => {
                onDownloadImageHandler()
                SendGTAGEvent(
                  'dowload_imagem_produto',
                  'Produto',
                  'Clica em baixar imagem do produto',
                  informations.name
                )
              }}>
              <Download />
            </button>

            <button className='card__share'
              onClick={() => {
                onShareLinkHandlerItem(informations.href)
                SendGTAGEvent(
                  'compartilha_produto',
                  'Produto',
                  'Clica em compartilhar produto único',
                  informations.href
                )
              }
              }>
              <Share />
            </button>
          </Cards>

        </Content>
      </BlockWishList>
    </ModalBackdrop>
  );
}

export default BaseModalImage